import React from 'react';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import Form from '~/src/features/center/Form';

import * as ST from './styled';

interface IProps {
    footerRef: React.RefObject<HTMLDivElement>,
    city: ICurrentCity,
}

const FormCallback: React.FC<IProps> = ({ footerRef, city }) => {

    return (
            <ST.GridContainer>
                <ST.Wrapper ref={footerRef}>
                <ST.Title>Остались вопросы? Мы вам перезвоним</ST.Title>
                <ST.Text>
                    Оставьте заявку – наш специалист свяжется с вами, ответит на ваши вопросы об услуге и стоимости
                </ST.Text>
                <Form
                    city={city}
                    withInputName={false}
                    withLegalText={true}
                    textButton={'Перезвоните мне'}
                    label={'bottom'}
                    data-test={'form'}
                />
            </ST.Wrapper>
        </ST.GridContainer>
    );
};

export default FormCallback;
